import { Navigate, Outlet } from "react-router-dom";
import ROUTES from "./NewRoutes";
import { useAuth } from "hooks/useAuth";
import { useEffect } from "react";
import { Modal, Select } from "antd";
import { getShopStores } from "apis/Network";
import { useDispatch, useSelector } from "react-redux";
import { setShop, setShopStores } from "store/shopSlice";
import { useTranslation } from "react-i18next";

export const ProtectedRoutes = ({ allowedRoles }) => {
  const { isAuthorized, adminRoles, forShop } = useAuth();
  const { selectedShop, shopStores } = useSelector((state) => state.shop);
  const { t } = useTranslation();

  const dispatch = useDispatch();

  // Fetch shop list if needed
  useEffect(() => {
    if (forShop && shopStores.length === 0) {
      getShopStores(
        (success) => {
          const formatted = success?.data?.map((shop) => ({
            label: shop.name,
            value: shop.id,
          }));
          dispatch(setShopStores(formatted || []));
        },
        () => {},
      );
    }
  }, [forShop, shopStores.length, dispatch]);

  const handleShopSelect = (shopId) => {
    dispatch(setShop(shopId));
  };

  // Role-based access control
  if (!adminRoles?.some((role) => allowedRoles?.includes(role))) {
    return isAuthorized ? (
      <Navigate to={ROUTES.NOT_HAVE_ACCESS} replace />
    ) : (
      <Navigate to={ROUTES.SIGNIN} replace />
    );
  }

  // Force shop selection for stock admins
  // if (adminRoles?.includes(20) && forShop && !selectedShop) {
  //   return (
  //     <Modal
  //       title={t("sidebar.selectShop")}
  //       open
  //       closable={false}
  //       footer={null}
  //       maskClosable={false}
  //     >
  //       <Select
  //         style={{ width: "100%" }}
  //         placeholder={t("sidebar.selectShop")}
  //         options={shopStores}
  //         onChange={handleShopSelect}
  //         value={selectedShop || undefined}
  //       />
  //     </Modal>
  //   );
  // }

  return <Outlet />;
};
